// Generated by ReScript, PLEASE EDIT WITH CARE


function toString(a) {
  switch (a) {
    case /* Deactivate */0 :
        return "Deactivate";
    case /* Delete */1 :
        return "Delete";
    case /* Approve */2 :
        return "Approve";
    case /* Discard */3 :
        return "Discard";
    
  }
}

export {
  toString ,
  
}
/* No side effect */
